import { createAction, props } from '@ngrx/store';
import { PaymentType } from 'src/app/core/enums/enums';
import { PassengerMco, WaiverData } from 'src/app/core/models/itinerary.model';
import { PaymentForm, ReissueRequestStatus } from 'src/app/core/models/reissue.model';
import { Step } from 'src/app/core/models/step.model';
import { ExchangeQuoteRequest } from 'src/app/core/models/voluntary-change.model';

//#region Load reissue steps
export const LoadSteps = createAction(
  '[Reissue] Load steps',
  props<{ paymentType: PaymentType }>()
);

export const LoadStepsSuccess = createAction(
  '[Reissue] Load payment steps success',
  props<{ steps: Step[] }>()
);

export const LoadStepsFail = createAction('[Reissue] Load payment steps fail');
//#endregion

//#region Reissue
export const Reissue = createAction(
  '[Reissue] Reissue',
  props<{ formOfPayment: PaymentForm; quote: ExchangeQuoteRequest }>()
);

export const ReissueSuccess = createAction(
  '[Reissue] Reissue success',
  props<{ requestStatus: ReissueRequestStatus; passengersMco: PassengerMco[] }>()
);

export const ReissueFail = createAction(
  '[Reissue] Reissue fail',
  props<{ requestStatus: ReissueRequestStatus; passengersMco?: PassengerMco[] }>(),
);

export const ReissueClear = createAction(
  '[Reissue] Reissue clear',
);
//#endregion

//#region general
export const SetBookingType = createAction(
  '[Reissue] Set Booking Type',
  props<{ isAutomatic: boolean; waiver?: WaiverData }>(),
);

export const SaveRemarks = createAction(
  '[Reissue] Save Remarks',
  props<{ remarks: string[] }>(),
);

export const CreateRemarks = createAction(
  '[Reissue] Create Remarks',
  props<{ remarks: string[] }>(),
);

export const CreateRemarksSuccess = createAction(
  '[Reissue] Create Remarks Success',
);

export const SaveDocsaSuccess = createAction(
  '[Reissue] Save Docsa Success',
);

export const Finalize = createAction('[Reissue] Finalize proccess');
export const UpdatePassengersMco = createAction('[Reissue] Update Passengers MCO',
  props<{ passengerMco: PassengerMco }>()
);
//#endregion
